import React, { useEffect } from "react";
import * as styles from "./FloatingInput.module.css";

// FloatingInput.jsx
const FloatingInput = React.forwardRef(
  ({ label, labelClassName = "", name, ...inputProps }, ref) => {
    return (
      <div className={styles.floating_label}>
        <input name={name} className={styles.input} ref={ref} {...inputProps} />
        <label htmlFor={name} className={labelClassName}>
          {label}
        </label>
      </div>
    );
  }
);

export default FloatingInput;
